import { formatNumber } from "src/v2/utils/formatter/format-number"

const hasValue = (value) => {
    return value !== null && value !== undefined && value !== ""
}

const hasAnyValue = (values) => {
    return values.some(hasValue)
}

const getValue = (value) => {
    return hasValue(value) ? value : "-"
}

export const getSummarySections = ({
    state,
    characterData,
    handleClickEmission,
}) => [
    {
        title: "Último Rating Emissão",
        gridProps: { xxxs: 4, sm: 6, lg: 4 },
        empty: state.isEmpty.ultimoRatingEmissao,
        emptyText: "Não há rating de emissão para o CETIP consultado",
        onClick: () => handleClickEmission("last_emission"),
        fields: [
            {
                label: "DATA VALIDADE",
                value: state.ultimoRatingEmissao?.data_validade,
            },
            {
                label: "FONTE",
                value: state.ultimoRatingEmissao?.fonte,
            },
            {
                label: "RATING",
                value: state.ultimoRatingEmissao?.rating,
            },
        ],
    },
    {
        title: "Último Rating Devedor",
        gridProps: { xxxs: 4, sm: 6, lg: 4 },
        empty: state.isEmpty.ultimoRatingDevedor,
        emptyText: "Não há rating devedor para o CETIP consultado",
        onClick: () => handleClickEmission("last_debtor"),
        fields: [
            {
                label: "DATA VALIDADE",
                value: state.ultimoRatingDevedor?.data_validade,
            },
            {
                label: "FONTE",
                value: state.ultimoRatingDevedor?.fonte,
            },
            {
                label: "RATING",
                value: state.ultimoRatingDevedor?.rating,
            },
        ],
    },
    {
        title: "Garantias",
        gridProps: { xxxs: 4, sm: 6, lg: 4 },
        empty: !hasAnyValue([
            characterData?.GarantiasReais,
            characterData?.GarantiasFidejussorias,
            characterData?.MitigadoresRiscoCredito,
        ]),
        emptyText: "Não há garantias para o CETIP consultado",
        onClick: () => handleClickEmission("guarantees"),
        fields: [
            {
                label: "REAIS",
                value: getValue(characterData?.GarantiasReais),
            },
            {
                label: "FIDEJUSSORIAS",
                value: getValue(characterData?.GarantiasFidejussorias),
            },
            {
                label: "MITIGADORES RISCO CREDITO",
                value: getValue(characterData?.MitigadoresRiscoCredito),
            },
        ],
    },
    {
        title: "Última Taxa Indicativa",
        gridProps: { xxxs: 4, sm: 6, lg: 4 },
        empty: state.isEmpty.ultimoPrecosProcessados,
        emptyText: "Não há taxa indicativa para o CETIP consultado",
        onClick: () => handleClickEmission("tax_indicative"),
        fields: [
            {
                label: "DATA REFERENCIA",
                value: state.ultimoPrecosProcessados?.data_referencia,
            },
            {
                label: "SPREAD CRÉDITO",
                value: formatNumber(
                    state.ultimoPrecosProcessados?.spread_credito,
                    4
                ),
            },
            {
                label: "% PUPAR",
                value: formatNumber(
                    state.ultimoPrecosProcessados?.percentual_pupar,
                    4
                ),
            },
        ],
    },
    {
        title: "Últimos Negócios",
        gridProps: { xxxs: 4, sm: 6, lg: 4 },
        empty: state.isEmpty.ultimoNegocio,
        emptyText: "Não há negócios para o CETIP consultado",
        onClick: () => handleClickEmission("history_last_negocitacions"),
        fields: [
            {
                label: "DATA REFERENCIA",
                value: state.ultimoNegocio?.data_referencia,
            },
            {
                label: "% PUPAR",
                value: formatNumber(state.ultimoNegocio?.pupar, 4),
            },
            {
                label: "SPREAD CRÉDITO",
                value: formatNumber(state.ultimoNegocio?.spread_credito, 4),
            },
        ],
    },
    {
        title: "Último Índice de Liquidez",
        gridProps: { xxxs: 4, sm: 6, lg: 4 },
        empty: state.isEmpty.ultimoIndiceLiquidez,
        emptyText: "Não há índice de liquidez para o CETIP consultado",
        onClick: () => handleClickEmission("index_liquidity"),
        fields: [
            {
                label: "DATA REFERENCIA",
                value: state.ultimoIndiceLiquidez?.data_referencia,
            },
            {
                label: "INDICE LIQUIDEZ",
                value: formatNumber(
                    state.ultimoIndiceLiquidez?.indice_liquidez,
                    4
                ),
            },
        ],
    },
    {
        title: "Último Evento de Crédito Emissão",
        gridProps: { xxxs: 4, sm: 6, lg: 4 },
        empty: state.isEmpty.ultimoCreditoEmissao,
        emptyText: "Não há evento de crédito de emissão para o CETIP consultado",
        onClick: () =>
            handleClickEmission("history_event_credit_emission"),
        fields: [
            {
                label: "DATA REFERENCIA",
                value: state.ultimoCreditoEmissao?.data_referencia,
            },
            {
                label: "SCORE EVENTO",
                value: formatNumber(
                    state.ultimoCreditoEmissao?.score_evento,
                    4
                ),
            },
            {
                label: "EVENTO CRÉDITO",
                value: state.ultimoCreditoEmissao?.evento_credito,
                gridProps: { xxxs: 4, md: 8, lg: 8 },
            },
        ],
    },
    {
        title: "Último Evento de Crédito Devedor",
        gridProps: { xxxs: 4, sm: 6, lg: 4 },
        empty: state.isEmpty.ultimoEventoCreditoDevedor,
        emptyText: "Não há evento de crédito devedor para o CETIP consultado",
        onClick: () =>
            handleClickEmission("history_event_credit_debtor"),
        fields: [
            {
                label: "DATA REFERENCIA",
                value: state.ultimoEventoCreditoDevedor?.data_referencia,
            },
            {
                label: "SCORE EVENTO",
                value: formatNumber(
                    state.ultimoEventoCreditoDevedor?.score_evento,
                    4
                ),
            },
            {
                label: "EVENTO CREDITO",
                value: state.ultimoEventoCreditoDevedor
                    ?.evento_credito_devedor,
                gridProps: { xxxs: 4, md: 8, lg: 8 },
            },
        ],
    },
    {
        title: "Tipo de Oferta",
        gridProps: { xxxs: 4, sm: 6, lg: 4 },
        empty: !hasAnyValue([characterData?.TipoOferta]),
        emptyText: "Não há tipo de oferta para o CETIP consultado",
        onClick: () => handleClickEmission("offer_type"),
        fields: [
            {
                label: "TIPO",
                value: getValue(characterData?.TipoOferta),
            },
        ],
    },
    {
        title: "Último Fato Relevante",
        gridProps: { xxxs: 4, sm: 12, lg: 12 },
        empty: !hasAnyValue([
            characterData?.DataReferenciaFatoRelevante,
            characterData?.FatoRelevante,
        ]),
        emptyText: "Não há fato relevante para o CETIP consultado",
        onClick: () => handleClickEmission("relevant_fact"),
        fields: [
            {
                label: "DATA REFERENCIA",
                value: getValue(characterData?.DataReferenciaFatoRelevante),
                gridProps: { xxxs: 4, sm: 2, lg: 2 },
            },
            {
                label: "FATO",
                value: getValue(characterData?.FatoRelevante),
                gridProps: { xxxs: 4, sm: 10, lg: 10 },
            },
        ],
    },
]